import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

const moduleTitles = {
  dashboard:      { title: 'Dashboard',       subtitle: 'Overview & key metrics' },
  userManagement: { title: 'User Management', subtitle: 'Manage system users and roles' },
  uploadExcel:    { title: 'Upload Excel',    subtitle: 'Import data from Excel files' },
  contacts:       { title: 'Contacts',        subtitle: 'Search and manage your lead contacts' },
  companies:      { title: 'Companies',       subtitle: 'Browse companies and manage their details' },
  dncBounce:      { title: 'DNC / Bounce',    subtitle: 'Manage do-not-contact and bounced email lists' },
};

export default function Header({ activeModule }) {
  const { auth, logout } = useAuth();
  const info = moduleTitles[activeModule] || moduleTitles.dashboard;
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });
  const initials = auth?.username ? auth.username.slice(0, 2).toUpperCase() : '??';
  const displayName = auth?.username || 'User';
  const role = auth?.role?.replace('ROLE_', '') || '';

  return (
    <header className="header">
      <div className="header-left">
        <div className="breadcrumb">
          <span className="breadcrumb-root">LDM</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
          <span className="breadcrumb-current">{info.title}</span>
        </div>
        <h1 className="header-title">{info.title}</h1>
        <p className="header-subtitle">{info.subtitle}</p>
      </div>
      <div className="header-right">
        <div className="header-date">{today}</div>
        <div className="header-user">
          <div className="header-avatar">{initials}</div>
          <div className="header-user-info">
            <span className="header-user-name">{displayName}</span>
            <span className="header-user-role">{role}</span>
          </div>
          <button className="header-logout-btn" onClick={logout} title="Sign out">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
